<loading class="tw-flex tw-justify-center tw-h-full" *ngIf="loading"></loading>
<div class="tw-fixed tw-z-10 tw-top-3 tw-left-6 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
  <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
</div>
@if (!loading) {
  <div class="tw-flex tw-flex-col tw-h-full tw-bg-gray-100">
    <section class="tw-flex-1 tw-flex tw-flex-col tw-gap-4 tw-overflow-y-auto tw-pt-18 tw-mb-4">
      @for (product of products; track $index) {
        <product-item [product]="product" (openCarousal)="openCarousalPopUp($event)" [itemIndex]="$index"></product-item>
      }
    </section>
    
    <!-- Image carousel pop up -->
    <div *ngIf="showProductCarousalPopUp" class="tw-fixed tw-w-full -tw-translate-y-1/2 tw-top-1/2 tw-z-30 tw-flex tw-justify-center tw-items-center tw-rounded-xl">
      <swiper #swiperCardsBanner="" class="" [config]="carouselConfig">
        <ng-container *ngFor="let product of products; let i = index">
          <div *swiperSlide class="tw-w-full tw-bg-white tw-rounded-xl tw-py-2 tw-h-[65vh] tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3">
            <div class="tw-w-11/12 tw-mx-auto tw-flex tw-justify-center tw-items-center">
              <img class="tw-w-40 tw-min-h-[50vh] tw-h-[50vh] tw-object-contain" [src]="product.product.productImage" alt="product_image"/>
            </div>
            <h1 class="tw-font-body tw-font-bold tw-text-500 tw-text-center tw-px-2 tw-h-2">{{ product.product.title }}</h1>
          </div>
        </ng-container>
      </swiper>
    </div>
    <div *ngIf="showProductCarousalPopUp" class="tw-fixed tw-inset-0 tw-z-20 tw-opacity-30 tw-bg-black" (click)="closeCarousalPopUp()"></div>
  </div>
}
